/**
 * Pagination params accepted by every purchases list endpoint. `page` is
 * 1-based. bos-api binds query keys case-insensitively, so these bind to
 * its `PaginationQuery` (`Page`, `PageSize`) as they are.
 */
export type PurchaseListQuery = {
    page?: number;
    pageSize?: number;
};

/**
 * Default/maximum page size requested by the list widgets. The lists sort
 * client-side over the full set, so we pull one page at the backend's cap
 * (bos-api clamps `pageSize` to 200). Lists beyond this truncate until true
 * pagination lands.
 */
export const PURCHASES_LIST_PAGE_SIZE = 200;
